import { createAction } from "@reduxjs/toolkit";
import { TToolStoreOrderItem } from "types";

export const streamUpdateToolStoreOrderItem = createAction(
  "toolStoreOrderItems/streamUpdate",
  (data: TToolStoreOrderItem) => ({
    payload: data,
  }),
);
